import { render, staticRenderFns } from "./status-form-files.vue?vue&type=template&id=67ba7cec&scoped=true&"
import script from "./status-form-files.vue?vue&type=script&lang=js&"
export * from "./status-form-files.vue?vue&type=script&lang=js&"
import style0 from "./status-form-files.vue?vue&type=style&index=0&id=67ba7cec&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ba7cec",
  null
  
)

export default component.exports